<div class="d-flex flex-column animated fadeInDown" style="align-items: center">
    <div><h2 class="logo-name" style="text-align: 'center'; padding-bottom: 30px">Brewers City Dock</h2></div>
    <div class="d-flex login-form">
        <form class="d-flex flex-column login-form" (submit)="login()">
            <dx-form [(formData)]="model" [showColonAfterLabel]="false" validationGroup="loginData" [showValidationSummary]="true" [showRequiredMark]="false">
                <dxi-item itemType="group">
                    <dxi-item dataField="userName"> <dxi-validation-rule type="required" message="User name is required"></dxi-validation-rule> </dxi-item>
                    <dxi-item dataField="password" [editorOptions]="{ mode: 'password' }">
                        <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
                    </dxi-item>
                </dxi-item>
            </dx-form>
            <dx-button text="Login" type="default" class="m-3" validationGroup="loginData" [useSubmitBehavior]="true"></dx-button>
        </form>
    </div>
</div>
